<template>
  <div class="buy-wrapper">
    <section class="buy-cell">
      <div class="title">选择</div>
      <div class="content" @click="showPopup">
        <p v-for="item in skuList" :key="item.sku">
          <span>{{item.name}}</span>
          <span v-html="getPriceCreditHtml(item.sellPrice,item.creditPrice)"></span>
        </p>
      </div>
    </section>
    <mt-popup v-model="visible" position="bottom" class="buy-popup">
      <div class="buy-container" @click.stop.prevent>
        <div class="buy-hd">
          <div class="title">选择</div>
          <div class="aside">在艺积分：{{myCredit}}</div>
        </div>
        <div class="buy-bd">
          <div class="buy-card">
            <div class="hd">
              <h2 class="title">选择商品</h2>
            </div>
            <div class="bd">
              <div class="sku-list">
                <div class="sku-item" :class="{active: item.balanceCount && item.sku === selectedSku.sku, disabled: !item.balanceCount}" v-for="item in skuList" :key="item.sku" @click="changeSkuItem(item)">
                  <div class="sku-item-price">
                    <div class="name">{{item.name}}</div>
                    <div class="price">
                      <p>
                        <span class="sell-price">
                          <template v-if="item.sellPrice || !item.creditPrice">¥{{item.sellPrice}}</template>
                          <template v-if="item.sellPrice && item.creditPrice">+</template>
                          <template v-if="item.creditPrice">{{item.creditPrice}}积分</template>
                        </span>
                        <span class="origin-price" v-if="item.originPrice">¥{{item.originPrice}}</span>
                      </p>
                      <p class="vip-price" v-if="item.hasVipPrice">会员价
                        <template v-if="item.vipPrice">¥{{item.vipPrice}}</template>
                        <template v-if="item.vipPrice && item.vipCreditsPrice">+</template>
                        <template v-if="item.vipCreditsPrice">{{item.vipCreditsPrice}}积分</template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="tips" v-if="selectedSku.stockSubjectShort">{{selectedSku.stockSubjectShort}}</p>
            </div>
          </div>
          <div class="buy-card buy-card-total">
            <div class="hd">
              <h2 class="title">选择数量</h2>
            </div>
            <div class="bd">
              <stepper v-model="selectedNum" :max="maxQuanity" />
            </div>
          </div>
        </div>
        <div class="buy-ft">
          <div class="buy-total" v-html="total"></div>
          <input type="button" class="buy-btn" value="确定" @click="onSubmit" :disabled="submitDisabled">
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
// 组件
import { Stepper } from 'vant'
// 接口
import { getTokenUser } from '@/api/base'
import { getCredit } from '@/api/credit'
// 方法
import { getPriceCreditHtml } from '@/utils/utils'

export default {
  name: 'buyCell',
  props: {
    value: { type: Boolean, default: false },
    is_redirect: { type: Boolean, default: false },
    skuValue: Object,
    skuList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: { Stepper },
  data() {
    return {
      visible: this.value,
      isVip: false,
      myCredit: 0,
      price: 0,
      selectedSku: {},
      selectedNum: 1,
      submitDisabled: false
    }
  },
  watch: {
    visible(value) {
      this.$emit('input', value)
      if (value) {
        this.getUser()
        this.getCredit()
      }
    },
    value(value) {
      this.visible = value
    },
    skuValue(value) {
      this.selectedSku = value
    },
    skuList: {
      handler(list) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i]
          if (item.balanceCount) {
            this.selectedSku = list[i]
            return false
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    // 最大购买
    maxQuanity() {
      let eachOrderMaxBuyCount = this.selectedSku.eachOrderMaxBuyCount
      let balanceCount = this.selectedSku.balanceCount
      if (balanceCount) {
        return balanceCount > eachOrderMaxBuyCount
          ? eachOrderMaxBuyCount
          : balanceCount
      } else {
        return 0
      }
    },
    // 合计
    total() {
      let price = 0
      let credit = 0
      let result = ''
      // 价格+积分
      if (this.selectedSku.hasVipPrice && this.isVip) {
        // 会员
        price = this.selectedSku.vipPrice
        credit = this.selectedSku.vipCreditsPrice
      } else {
        // 非会员
        price = this.selectedSku.sellPrice
        credit = this.selectedSku.creditPrice
      }
      // 价格
      if (price || !credit) {
        result += `<span class="t1">¥</span><span class="t2">${(
          price * this.selectedNum
        ).toFixed(2)}</span>`
      }
      // 价格+积分
      if (price && credit) {
        result += '<span class="t1">+</span>'
      }

      // 积分
      if (credit) {
        result += price
          ? `<span class="t1">${credit * this.selectedNum}积分</span>`
          : `<span class="t2">${credit *
              this.selectedNum}</span><span class="t1">积分</span>`
      }

      return `<span>合计</span>${result}`
    }
  },
  methods: {
    getPriceCreditHtml,
    // 显示使用优惠券
    showPopup() {
      this.visible = true
    },
    // 获取用户信息
    getUser() {
      getTokenUser().then(response => {
        // 用户vip
        this.isVip = response.data.vipEndTime > +new Date()
      })
    },
    // 获取我的积分
    getCredit() {
      getCredit().then(response => {
        this.myCredit = response.data.totalCredits
      })
    },
    // 改变item
    changeSkuItem(item) {
      if (item.balanceCount) {
        this.selectedSku = item
        this.selectedNum = 1
        this.$emit('sku-change', item)
      }
    },
    onSubmit() {
      if (!this.selectedSku || (this.selectedSku && !this.selectedSku.sku)) {
        this.$toast('请选择商品')
        return false
      }
      if (!this.selectedSku.balanceCount) {
        this.$toast('该商品已售罄')
        return false
      }
      if (this.selectedNum > this.selectedSku.balanceCount) {
        this.$toast('库存不足')
        this.selectedNum = this.selectedSku.balanceCount
        return false
      }
      let credit =
        this.selectedSku.hasVipPrice && this.isVip
          ? this.selectedSku.vipCreditsPrice
          : this.selectedSku.creditPrice
      if (credit * this.selectedNum > this.myCredit) {
        this.$toast('积分不足')
        return false
      }
      this.createOrder()
    },
    createOrder() {
      this.submitDisabled = true
      this.$router.push({
        path: '/my/order/confirm',
        query: {
          order_type: '2',
          order_param: JSON.stringify({
            payType: 'NONE',
            skuRequestList: [
              { count: this.selectedNum, sku: this.selectedSku.sku }
            ]
          }),
          from: 'webapp',
          redirect_uri: location.href,
          is_redirect:this.is_redirect
        }
      })
    }
  },
  created() {
    // this.getUser()
    // this.getCredit()
  }
}
</script>
<style>
.buy-cell {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 0.2rem;
  margin-bottom: 0.14rem;
  background-color: #fff;
}
.buy-cell::after {
  content: ' ';
  position: absolute;
  top: 50%;
  right: 0.2rem;
  width: 0.08rem;
  height: 0.08rem;
  transform: translateY(-50%) rotate(45deg);
  border: 1px solid #dadada;
  border-bottom-width: 0;
  border-left-width: 0;
}
.buy-cell .title {
  padding: 0.16rem 0;
  font-size: 16px;
  line-height: 0.22rem;
  color: #999;
}
.buy-cell .content {
  position: relative;
  flex: 1;
  padding: 0.16rem 0.12rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.buy-cell .content p {
  position: relative;
  display: inline-block;
  color: #3c3c3c;
}
.buy-cell .content p:after {
  content: '/';
  padding: 0 5px;
}
.buy-cell .content p:last-child:after {
  display: none;
}

.buy-popup {
  max-width: 750px;
  width: 100%;
  background-color: #fff;
}
.buy-container .buy-hd {
  position: relative;
}
.buy-container .buy-hd .aside {
  position: absolute;
  right: 20px;
  top: 0;
  bottom: 0;
  font-size: 12px;
  line-height: 56px;
  color: #999;
  z-index: 2;
}
.buy-container .buy-hd .title {
  position: relative;
  padding: 0 20px;
  height: 56px;
  font-size: 18px;
  color: #3c3c3c;
  line-height: 56px;
  text-align: center;
  box-shadow: 0px 1px 0px 0px rgba(218, 218, 218, 0.5);
  z-index: 1;
}
.buy-container .buy-bd {
  height: 320px;
  background-color: #fcfcfc;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.buy-container .buy-ft {
  position: relative;
  display: flex;
  box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.05);
  z-index: 1;
}
.buy-container .buy-ft .buy-total {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: baseline;
  height: 48px;
  font-size: 14px;
  line-height: 48px;
  color: #3c3c3c;
  letter-spacing: 1px;
  padding-right: 25px;
}
.buy-container .buy-ft .buy-total .t1 {
  font-size: 13px;
  font-weight: 600;
  color: #ff615c;
}
.buy-container .buy-ft .buy-total .t2 {
  font-size: 20px;
  font-weight: 600;
  color: #ff6260;
}
.buy-container .buy-ft .buy-btn {
  width: 0.92rem;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 48px;
  color: #fff;
  letter-spacing: 2px;
  background: linear-gradient(
    -117.7deg,
    rgba(87, 174, 241, 1),
    rgba(72, 160, 255, 1)
  );
  cursor: pointer;
}
.buy-container .buy-ft .buy-btn:disabled {
  color: #999;
  background: #e5e5e5;
}

.buy-card {
  padding: 0 20px;
  margin: 14px 0;
}
.buy-card .hd .title {
  font-size: 16px;
  font-weight: 400;
  color: #3c3c3c;
  line-height: 22px;
}
.buy-card .bd {
  padding-top: 14px;
}
.buy-card-total {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.buy-card-total .hd {
  flex: 1;
}
.buy-card-total .bd {
  padding-top: 0;
}
.buy-card .tips {
  padding-top: 14px;
  font-size: 12px;
  color: #999;
}
.sku-list {
  margin-top: -10px;
}
.sku-item {
  position: relative;
  display: inline-block;
  max-width: 100%;
  min-width: 60px;
  margin-right: 10px;
  margin-top: 10px;
  padding: 0 10px;
  background: #fff;
  border: 1px solid #dadada;
  border-radius: 4px;
  color: #666;
  cursor: pointer;
  /* white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden; */
}
.sku-list .sku-item:last-child {
  margin-right: 0;
}
.sku-item.disabled::after {
  content: '';
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.5);
}
.sku-item.active {
  border: 1px solid #57aef1;
  background: rgba(238, 246, 253, 1);
  color: #57aef1;
}
.sku-item-price {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  min-height: 40px;
}
.sku-item-price .name {
  flex: 1;
  font-size: 12px;
  line-height: 16px;
  color: #999;
  white-space: normal;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}
.sku-item-price .price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  padding-left: 10px;
  min-height: 30px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  border-left: 1px solid #dadada;
}
.sku-item-price .price .sell-price {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}
.sku-item-price .price .origin-price {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
}
.sku-item-price .price .vip-price {
  padding-top: 2px;
  font-size: 12px;
  color: #57aef1;
}
.sku-item.active .sku-item-price .name {
  color: #57aef1;
}
.van-stepper .van-stepper__input {
  width: 44px;
  height: 26px;
  line-height: 26px;
}
/* .van-stepper .van-stepper__minus,
.van-stepper .van-stepper__plus {
  width: 30px;
  height: 30px;
  border-radius: 0;
} */
.van-stepper .van-stepper__minus::after,
.van-stepper .van-stepper__minus::before,
.van-stepper .van-stepper__plus::after,
.van-stepper .van-stepper__plus::before {
  background-color: #48a0ff;
}
.van-stepper .van-stepper__minus--disabled::after,
.van-stepper .van-stepper__minus--disabled::before,
.van-stepper .van-stepper__plus--disabled::after,
.van-stepper .van-stepper__plus--disabled::before {
  background-color: #c9c9c9;
}
.van-stepper .van-stepper__minus::after,
.van-stepper .van-stepper__plus::after {
  width: 2px;
  height: 10px;
}
.van-stepper .van-stepper__minus::before,
.van-stepper .van-stepper__plus::before {
  width: 10px;
  height: 2px;
}
</style>
